<template>
  <div class="relative flex h-20 font-bold">
    <div class="relative max-xl:mx-auto xl:w-full">
      <div
        class="text-primary-lightest absolute left-0 top-0 -z-10 -translate-x-1/2 text-[4.375rem] leading-10"
      >
        {{ number }}
      </div>
      <div class="flex items-center">
        <div class="text-primary mr-3 flex whitespace-nowrap text-3xl">
          <slot></slot>
        </div>
        <div
          class="hidden w-full border-4 border-t border-dotted md:block"
        ></div>
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: String,
      default: "00",
      required: true,
    },
  },
};
</script>
